<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    title: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    breadcrumbs: {
      type: String,
      required: true,
    },
  },
});
</script>
<template>
  <a
    :href="url"
    class="group block rounded-sm p-3 font-semibold transition-colors hover:bg-ick-neutral-100"
  >
    <div v-if="breadcrumbs" class="mb-1 text-xs text-ick-purple-500">
      {{ breadcrumbs }}
    </div>
    <div class="text-sm">
      {{ title }}
    </div>
  </a>
</template>
